import { takeLatest, put, call, fork } from "redux-saga/effects";
import { APPLICANT_VERIFICATION_ACTIONS } from "constants/actions";
import {
    fetchedAssociatesVerificationList,
    failedFetchAssociatesVerificationList,
} from "./../actions";
import {
    message
} from "antd";
import CompanyService from "services/company-service";

function* fetchApplicantVerificationList({ payload: { companyId } }) {
    try{
        const {data, error} = yield call(CompanyService.getAssociateVerificationDetails, companyId);
        if(!error) {
            yield put(fetchedAssociatesVerificationList(companyId, data));
        } else {
            yield put(failedFetchAssociatesVerificationList(companyId, error));
        }
    } catch(error) {
        if(error.response.status >= 500) {
            message.error("Internet Connectivity Issue. Try Again");
        }
        yield put(failedFetchAssociatesVerificationList(companyId, error));
    }
}

export default fork (function*() {
    yield takeLatest(
        APPLICANT_VERIFICATION_ACTIONS.FETCH_ASSOCIATES_VERIFICATION_LIST,
        fetchApplicantVerificationList
    );
});